import React, { useMemo, useState } from "react";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import SidebarContent from "./SidebarContent";
import { Link } from "react-router-dom";
import { LOGO } from "constants/Client";
import { connect } from "react-redux";
import PropTypes from "prop-types";

const Sidebar = props => {
  const [logo, setLogo] = useState(LOGO());

  useMemo(() => {
    if (!localStorage.getItem("company_logo")) return;
    setLogo(LOGO());
  }, [localStorage.getItem("company_logo")]);

  return (
    <React.Fragment>
      <div className='vertical-menu'>
        <div className='navbar-brand-box'>
          {props?.leftNavbar && (
            <Link to='/' className='logo logo-light'>
              <span className='logo-sm'>
                <img src={logo} alt='' className='rounded' height='55px' />
              </span>
              <span className='logo-lg'>
                <img src={logo} alt='' className='rounded' style={{ height: "70px", width: "70px", objectFit: "contain" }} />
              </span>
            </Link>
          )}
        </div>
        <div data-simplebar className='h-100'>
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className='sidebar-background'></div>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStatetoProps = state => {
  return {
    leftNavbar: state.Layout.leftNavbar,
  };
};
export default connect(mapStatetoProps, {})(withRouter(withTranslation()(Sidebar)));
